/* import __COLOCATED_TEMPLATE__ from './bpcap-circuit.hbs'; */
import Component from '@glimmer/component';
import type { CapacitorItem } from './bypass-capacitors-container';

interface BypassCapacitorCircuitArgs {
  circuitValues: CapacitorItem;
  index: number;
}

export default class BypassCapacitorCircuit extends Component<BypassCapacitorCircuitArgs> {
  yTranslate = 0;

  get xTranslate(): number {
    return this.args.index * 100;
  }
}
